const ACCESS_TITLE_MAP = {
  auxiliaryInputs: 'Auxiliary Inputs',
  auxiliaryOutputs: 'Auxiliary Outputs',
  contacts: 'Contacts',
  doorOpeners: 'Door Openers',
  locks: 'Locks',
  readers: 'Readers',
  rexs: 'Request to Exit Devices',
  tampers: 'External Tampers'
}

export default keyStr => ACCESS_TITLE_MAP[keyStr] || (keyStr[0].toUpperCase() + keyStr.slice(1).replace(/[A-Z]/, m => ' ' + m))



// WEBPACK FOOTER //
// ./src/helpers/accessControl/toTitle.js